<template>
  <NewLoaderComponent v-if="isLoading" />
  <AllertComponent />
  <InfoComponent />

  <v-app class="main-fos" style="background: transparent">
    <v-container fluid>
      <SystemBar :online="true"/>
      <v-main v-if="access && checked">
        <v-container fluid style="margin: 0; padding: 0; position: relative;">
          <router-view />
        </v-container>
      </v-main>
      <v-main v-if="!access && checked">
        <v-container fluid style="margin: 0; padding: 0; position: relative;">
          ОШИБКА 403: ОТКАЗАНО В ДОСТУПЕ
        </v-container>
      </v-main>
    </v-container>
  </v-app>
</template>

<script>
import { MenuDrawer } from "@/store/Drawers/MenuDrawer";
import { RouterHandler } from "@/store/RouterHandler";
import { ErrorStore } from "@/store/ErrorStore";
import { TokenGUIDStore } from "@/store/global/SessionStore";
import SystemBar from "@/components/Global/SystemBar.vue";
import AllertComponent from "@/components/Global/AllertComponent.vue";
import { isLoader } from "@/store/Loader";
import NewLoaderComponent from "@/components/Different/NewLoaderComponent.vue";
import { UserStore } from "@/store/GigaUser";
import { AppsStore } from "@/store/AppsList";
import Cookies from "js-cookie";
import { District__Guid, District__Info, DistrictsList } from "@/store/global/districts.dictionary";
import InfoComponent from "@/components/Global/InfoComponent.vue";

export default {
  components: { InfoComponent, NewLoaderComponent, AllertComponent, SystemBar },
  async beforeMount() {
    await this.check_session()
  },
  mounted() {
    this.errors = []
  },
  data() {
    return {
      access: false,
      checked: false,
      drawers: {
        tools: false
      },
      is_initialized: false
    }
  },
  methods: {
    check_session: async function () {
      if (Cookies.get('token')) {
        this.session_token = Cookies.get('token')
        await this.check_app()
      } else {
        if (this.$config.REDIRECT) {
          window.location.replace(`${this.$config.SSL}://${this.$config.AUTH_ADDRESS}/`);
        }
      }
    },
    get_user_data: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.ONETEST}/GetUserData`
      let config = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }

      await fetch(url, config)
          .then(async response => {
            if (!response.ok) {
              throw `Ошибка получения данных пользователя`
            }
            return await response.json()
          })
          .then(async result => {
            if (result) {
              this.user = result
              this.district_guid = this.user.district_guid
            }
          }).catch(err => {
            console.error(err)
          })
    },
    get_apps: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.ONETEST}/GetApps`
      let config = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: JSON.stringify({
          app: this.$config.WS_APP
        })
      }

      await fetch(url, config)
          .then(async response => {
            if (!response.ok) {
              throw `Ошибка получения списка приложений`
            }
            return await response.json()
          })
          .then(result => {
            this.apps = result
            this.access = true
          }).catch(err => {
            console.error(err)
          })
    },
    get_available_districts: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.ONETEST}/AvailableDistricts`
      let meta = {
        method: 'GET',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }
      await fetch(url, meta)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка получения участков!`
            }
          })
          .then(async result => {
            this.districts = result
          }).catch(err => {
            console.warn(err)
          }).finally(() => {
            this.loading = false
          })
    },
    check_app: async function () {
      console.log('Проверка доступа к приложению ...')
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.ONETEST}/EIS_GetButtons`
      let config = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }

      await fetch(url, config)
          .then(async response => {
            if (!response.ok) {
              throw `Ошибка получения списка приложений`
            }
            return await response.json()
          })
          .then(async result => {
            let app = result.filter(item => {
              return item.app_id === this.$config.WS_APP
            })
            if (app.length > 0) {
              await this.get_user_data()
              await this.get_apps()
              await this.get_available_districts()

              console.log('Доступ разрешён!')
            }

          }).catch(err => {
            console.error(err)
          }).finally(() => {
            this.checked = true
          })
    }
  },
  watch: {
    async district_guid() {
      await this.get_district_data()
    }
  },
  computed: {
    apps: {
      get() {
        return AppsStore().get()
      },
      set(value) {
        AppsStore().set(value)
      }
    },
    districts: {
      get() {
        return DistrictsList().get()
      },
      set(value) {
        DistrictsList().set(value)
      }
    },
    district_info: {
      get() {
        return District__Info().get()
      },
      set(value) {
        District__Info().set(value)
      }
    },
    district_guid: {
      get() {
        return District__Guid().get()
      },
      set(value) {
        District__Guid().set(value)
      }
    },
    isLoading: {
      get() {
        return isLoader().get()
      },
      set(value) {
        return isLoader().set(value)
      }
    },
    errors: {
      get() {
        return ErrorStore().get()
      },
      set(value) {
        ErrorStore().set(value)
      }
    },
    drawer: {
      get() {
        return MenuDrawer().get()
      },
      set(value) {
        MenuDrawer().set(value)
      }
    },
    g_path: {
      get() {
        return RouterHandler().get()
      },
      set(value) {
        RouterHandler().set(value)
      }
    },
    session_token: {
      get() {
        return TokenGUIDStore().get()
      },
      set(value) {
        TokenGUIDStore().set(value)
      }
    },
    user: {
      get() {
        return UserStore().get()
      },
      set(value) {
        UserStore().set(value)
      }
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'DinCy';
  src: url('assets/fonts/DinCyRg.ttf');
}
@font-face {
  font-family: 'DinCyB';
  src: url('assets/fonts/DinCyBk.ttf');
}

* {
  font-family: 'DinCy', sans-serif;
}

html::-webkit-scrollbar, body::-webkit-scrollbar {
  width: 0px !important;
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #bad0dc;
  border-radius: 0;
  transition: 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #87a1ae;
  cursor: grab;
}

::-webkit-scrollbar-thumb:active {
  background-color: #51656f;
  cursor: grabbing;
}

.main-fos {
  background-color: #EEEEEE;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3CradialGradient id='a' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23FFFFFF'/%3E%3Cstop offset='1' stop-color='%23EEEEEE'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='0' y1='750' x2='1550' y2='750'%3E%3Cstop offset='0' stop-color='%23f7f7f7'/%3E%3Cstop offset='1' stop-color='%23EEEEEE'/%3E%3C/linearGradient%3E%3Cpath id='s' fill='url(%23b)' d='M1549.2 51.6c-5.4 99.1-20.2 197.6-44.2 293.6c-24.1 96-57.4 189.4-99.3 278.6c-41.9 89.2-92.4 174.1-150.3 253.3c-58 79.2-123.4 152.6-195.1 219c-71.7 66.4-149.6 125.8-232.2 177.2c-82.7 51.4-170.1 94.7-260.7 129.1c-90.6 34.4-184.4 60-279.5 76.3C192.6 1495 96.1 1502 0 1500c96.1-2.1 191.8-13.3 285.4-33.6c93.6-20.2 185-49.5 272.5-87.2c87.6-37.7 171.3-83.8 249.6-137.3c78.4-53.5 151.5-114.5 217.9-181.7c66.5-67.2 126.4-140.7 178.6-218.9c52.3-78.3 96.9-161.4 133-247.9c36.1-86.5 63.8-176.2 82.6-267.6c18.8-91.4 28.6-184.4 29.6-277.4c0.3-27.6 23.2-48.7 50.8-48.4s49.5 21.8 49.2 49.5c0 0.7 0 1.3-0.1 2L1549.2 51.6z'/%3E%3Cg id='g'%3E%3Cuse href='%23s' transform='scale(0.12) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.2) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.25) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(0.3) rotate(-20)'/%3E%3Cuse href='%23s' transform='scale(0.4) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(0.5) rotate(20)'/%3E%3Cuse href='%23s' transform='scale(0.6) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.7) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.835) rotate(-40)'/%3E%3Cuse href='%23s' transform='scale(0.9) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(1.05) rotate(25)'/%3E%3Cuse href='%23s' transform='scale(1.2) rotate(8)'/%3E%3Cuse href='%23s' transform='scale(1.333) rotate(-60)'/%3E%3Cuse href='%23s' transform='scale(1.45) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(1.6) rotate(10)'/%3E%3C/g%3E%3C/defs%3E%3Cg transform='translate(440 0)'%3E%3Cg transform='translate(0 690)'%3E%3Ccircle fill='url(%23a)' r='3000'/%3E%3Cg opacity='0.5'%3E%3Ccircle fill='url(%23a)' r='2000'/%3E%3Ccircle fill='url(%23a)' r='1800'/%3E%3Ccircle fill='url(%23a)' r='1700'/%3E%3Ccircle fill='url(%23a)' r='1651'/%3E%3Ccircle fill='url(%23a)' r='1450'/%3E%3Ccircle fill='url(%23a)' r='1250'/%3E%3Ccircle fill='url(%23a)' r='1175'/%3E%3Ccircle fill='url(%23a)' r='900'/%3E%3Ccircle fill='url(%23a)' r='750'/%3E%3Ccircle fill='url(%23a)' r='500'/%3E%3Ccircle fill='url(%23a)' r='380'/%3E%3Ccircle fill='url(%23a)' r='250'/%3E%3C/g%3E%3Cg %3E%3Cuse href='%23g' transform='rotate(10)'/%3E%3Cuse href='%23g' transform='rotate(120)'/%3E%3Cuse href='%23g' transform='rotate(240)'/%3E%3C/g%3E%3Ccircle fill-opacity='0.29' fill='url(%23a)' r='3000'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
</style>
